import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchMoreProjectsToAssignQueryVariables = Types.Exact<{
  successorArgs: Types.RateSheetSuccessorArgsInput;
  token?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type SearchMoreProjectsToAssignQuery = { __typename?: 'QueryModel', projects?: { __typename?: 'ProjectsQueryModelOld', search?: { __typename?: 'ConnectionOfProject', token?: string | null, records?: Array<{ __typename?: 'Project', number: number, name: string, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null } | null> | null } | null } | null };


export const SearchMoreProjectsToAssignDocument = gql`
    query SearchMoreProjectsToAssign($successorArgs: RateSheetSuccessorArgsInput!, $token: String) {
  projects {
    search(successorArgs: $successorArgs, token: $token) {
      token
      records {
        number
        name
        customer {
          name
          number
        }
      }
    }
  }
}
    `;

/**
 * __useSearchMoreProjectsToAssignQuery__
 *
 * To run a query within a React component, call `useSearchMoreProjectsToAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMoreProjectsToAssignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMoreProjectsToAssignQuery({
 *   variables: {
 *      successorArgs: // value for 'successorArgs'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSearchMoreProjectsToAssignQuery(baseOptions: Apollo.QueryHookOptions<SearchMoreProjectsToAssignQuery, SearchMoreProjectsToAssignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMoreProjectsToAssignQuery, SearchMoreProjectsToAssignQueryVariables>(SearchMoreProjectsToAssignDocument, options);
      }
export function useSearchMoreProjectsToAssignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMoreProjectsToAssignQuery, SearchMoreProjectsToAssignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMoreProjectsToAssignQuery, SearchMoreProjectsToAssignQueryVariables>(SearchMoreProjectsToAssignDocument, options);
        }
export type SearchMoreProjectsToAssignQueryHookResult = ReturnType<typeof useSearchMoreProjectsToAssignQuery>;
export type SearchMoreProjectsToAssignLazyQueryHookResult = ReturnType<typeof useSearchMoreProjectsToAssignLazyQuery>;
export type SearchMoreProjectsToAssignQueryResult = Apollo.QueryResult<SearchMoreProjectsToAssignQuery, SearchMoreProjectsToAssignQueryVariables>;